import React from "react"
import ImageHome from "@components/MockableImages"

const TwoComponents = ({
  theme = "blue",
  col1content = <></>,
  col2content = <></>,
  col1class = "",
  col2class = "",
  containerClass = "",
  reverse = false,
  backgroundImage = null,
  backgroundStyle = null,
  extraBackgroundClass = {},
}) => {
  let backgroundColor = "bg-dblue"
  let font = "font-inter "

  switch (theme) {
    case "blue":
      font += "text-white"
      break
    case "white":
      backgroundColor = "bg-white"
      font += "text-white"
      break
    case "lBlue":
      backgroundColor = "bg-lblue"
      font += "text-white"
      break
  }
  let styleBackground = {}
  if (backgroundImage) {
    styleBackground = {
      backgroundImage: `url(${backgroundImage})`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: backgroundStyle?.backgroundPosition
        ? backgroundStyle.backgroundPosition
        : "bottom right",
      ...extraBackgroundClass,
    }
  }
  return (
    <div
      className={`flex justify-center ${backgroundColor}`}
      style={styleBackground}
    >
      <div
        className={`relative flex w-full   ${
          reverse ? "flex-col-reverse" : "flex-col"
        } md:flex-row ${containerClass} desk:max-w-[1920px]  `}
      >
        <div className={`flex md:w-1/2 z-10 ${col1class}`}>{col1content}</div>
        <div className={`flex md:w-1/2 z-10 ${col2class}`}>{col2content}</div>
      </div>
    </div>
  )
}

export default TwoComponents
